import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10464727"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emojis" }
const _hoisted_2 = ["data-index"]

import { useGameState } from "@/services/composition";
import gsap from "gsap";
import { computed, watch, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  emojis: {
    type: Array,
    required: true
  }
},
  setup(__props) {

const props = __props

const { state } = useGameState()



const TEX_SIZE =  window.innerHeight
const EMOJI_MIN = .107
const EMOJI_MAX = .157
const EMOJI_MARGIN = .1

const onEnter = (el: Element, onComplete: gsap.Callback) => {
  
  const size = (EMOJI_MIN + Math.random() * (EMOJI_MAX - EMOJI_MIN)) * TEX_SIZE
  const baseX = EMOJI_MARGIN * TEX_SIZE + Math.random() * (TEX_SIZE * (1 - EMOJI_MARGIN * 2) - size)
  const y = TEX_SIZE

  gsap.set(el, { x: baseX, y })

  gsap.to(el, {
    opacity: 0,
    duration: 1.75,
    delay: 0.25,
    ease: 'linear'
  })

  gsap.to(el, {
    y: - size,
    duration: 2,
    ease: 'power1.out',
    onUpdate: function() {
      const x = baseX + Math.cos((this.progress() || 1) * 10) * size * 0.1
      gsap.set(el, { x })
    },
    onComplete
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      css: false,
      onEnter: onEnter
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.emojis, (emoji, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "emoji",
            key: emoji.toString(),
            "data-index": index
          }, null, 8, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})